import type { NotificationGroupedByDate } from '@/modules/Customer/interface/Notification';
import { useEffect, useState } from 'react';
import { captureException } from '@sentry/nextjs';
import { useGetNotifications } from '@/modules/Customer/http/client/useGetNotifications';
export const useNotifications = () => {
  const {
    data: notifications,
    status,
    error
  } = useGetNotifications();
  const [notificationsQuantity, setNotificationsQuantity] = useState(0);
  const countNotifications = (data: Partial<NotificationGroupedByDate>) => {
    if (Object.values(data).length > 0) {
      let count = 0;
      count += data['HOJE']?.length ?? 0;
      count += data['ONTEM']?.length ?? 0;
      setNotificationsQuantity(count);
    }
  };
  useEffect(() => {
    if (status === 'success') {
      countNotifications(notifications);
    }
    if (status === 'error') {
      captureException({
        tag: 'useNotifications.countNotifications',
        error,
        message: `Erro ao captar dados de notificações`
      });
    }
  }, [error, notifications, status]);
  return {
    notifications,
    notificationsQuantity
  };
};